import { Deal, GetOptions } from "@/core";
import { repositoryHost } from "@/repositories";
import { serviceHost } from "@/services";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { getNextPageParam } from "../utils/page-params";

const databaseService = serviceHost.getDatabaseService();
const dealRepository = repositoryHost.getDealRepository(databaseService);

export const useGetDealById = (dealId: string) => {
  return useQuery({
    queryKey: ["dealId", dealId],
    queryFn: async () => {
      return dealRepository.get({ id: dealId });
    },
    enabled: !!dealId,
  });
};

export const useDeals = (options: GetOptions<Deal>) => {
  return useInfiniteQuery({
    queryKey: ["deals", "get", JSON.stringify(options)],
    queryFn: ({ pageParam }) => {
      return dealRepository.getAll({
        ...options,
        pagination: {
          ...options.pagination,
          cursor: pageParam,
        },
      });
    },
    initialPageParam: "",
    getNextPageParam: getNextPageParam(options),
  });
};
